
<template>
  <section>
    <div class="headview">
      <img
        v-bind:src="userInfo.headurl"
        class="headimg"
        @click="openSearchMain"
      />
      <div class="data">
        <div>{{ userInfo.name }}</div>
        <div>手机号码 ：{{ userInfo.phone }}</div>
        <div>
          余额 ：<span class="text_red">{{ userInfo.credit }}</span>
        </div>
      </div>
    </div>

    <el-dialog
      title="查找可派帐号"
      :visible.sync="UserVisible"
      v-model="UserVisible"
      width="40%"
      custom-class="minheight"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-col
        :span="24"
        class="toolbar comptoolbar"
        style="padding-bottom: 0px"
      >
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="searchVal"
              :placeholder="$t('pleaseEnter') + '...'"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="callFunc()"
              size="small"
              :loading="listLoading"
              >{{ $t("search") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div class="headview selview" v-if="selectUser.customerId != 0">
          <img
            v-bind:src="selectUser.headurl"
            class="headimg"
            @click="openSearchMain"
          />
          <div class="data">
            <div>{{ selectUser.name }}</div>
            <div>手机号码 ：{{ selectUser.phone }}</div>
            <div class="yuer">
              <div>
                余额 ：<span class="text_red">{{ selectUser.credit }}</span>
              </div>
              <div class="butr">
                <el-button type="primary" size="mini" @click.native="qrseluser"
                  >确定选择</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </section>
</template>
<script>
import util from "util/date";
import { getKoipyUserInfo } from "@/api/api";
export default {
  name: "SearchKoipyUser",
  data() {
    return {
      UserVisible: false,
      searchVal: "",
      userInfo: {
        headurl: "/static/images/selectuser.png",
        name: "",
        phone: "",
        credit: 0,
      },
      selectUser: {
        customerId: 0,
        headurl: "/static/images/selectuser.png",
        name: "",
        phone: "",
        credit: 0,
      },
      listLoading: false,
    };
  },
  props: {
    value: Number,
  },
  methods: {
    openSearchMain() {
      this.UserVisible = true;
    },
    callFunc(item) {
      this.getList();
    },
    qrseluser() {
      this.userInfo = this.selectUser;
      this.$emit("input", parseInt(this.userInfo.customerId));
      this.UserVisible = false;
    },
    getList() {
      let para = {
        key: this.searchVal,
      };
      this.listLoading = true;
      getKoipyUserInfo(para).then((res) => {
        if (res.data.response.customerId != undefined) {
          this.selectUser = res.data.response;
        } else {
          this.selectUser = {
            customerId: 0,
            headurl: "/static/images/selectuser.png",
            name: "",
            phone: "",
            credit: 0,
          };
        }
        this.listLoading = false;
      });
    },
  },
  watch: {
    value() {
      if (this.value == null)
        this.userInfo = {
          headurl: "/static/images/selectuser.png",
          name: "",
          phone: "",
          credit: 0,
        };
    },
  },
};
</script>
<style scoped>
.headview {
  display: flex;
  align-items: center;
}
.headview img {
  margin-right: 20px;
}
.headview .data {
  width: calc(100% - 100px);
}
.headview .data div {
  line-height: 25px;
}
.headimg {
  width: 80px;
  height: 80px;
  border: 3px solid #f7a600;
  border-radius: 50%;
}
.selview {
  margin-top: 20px;
}
.yuer {
  display: flex;
}
.yuer div {
  flex: 1;
}
.butr {
  text-align: center;
}
</style>